export const numberOfDependentChildren = [
  { value: '', label: 'Seleccionar' },
  { value: '0', label: '0' },
  { value: '1', label: '1' },
  { value: '2', label: '2' },
  { value: '3', label: '3' },
  { value: '4', label: '4' },
  { value: 'Más de 4', label: 'Más de 4' },
]
